import { useDispatch, useSelector } from "react-redux";
import { Stack, Typography, Button } from "@financeable-com-au/financeable-ui";
import {
  setSubmissionModalOpen,
  setIntercomChatOptions,
  applicationSelector,
  // @ts-expect-error: ignoring as it is existing js file
} from "@/store/slices/applicationFormSlice";
import type { ApplicationFormSlice, ApplicationState } from "@/store/slices/types/applicationFormSlice";
import { useFeatureFlags } from "@/utils/featureFlags/useFeatureFlags";
import { ErrorMessageV1 } from "@/components/SubmissionModal/SubmissionDenied/ErrorMessageV1";
import { ErrorMessage } from "@/components/SubmissionModal/SubmissionDenied/ErrorMessage";
import { useApplicationRouteType } from "@/components/SubmissionModal/hooks/useApplicationRouteType";
import { withIndefiniteArticle } from "@/utils/indefiniteArticle";

const SubmissionDenied = () => {
  const applicationRouteType = useApplicationRouteType();
  const { user } = useSelector<ApplicationFormSlice, ApplicationState>(applicationSelector);
  const { errorResponseApiFlag } = useFeatureFlags();
  const dispatch = useDispatch();

  const handleCloseSubmissionModal = () => {
    dispatch(setSubmissionModalOpen({ isOpen: false }));
  };

  const handleContactSupport = () => {
    dispatch(
      setIntercomChatOptions({
        showIntercom: true,
        intercomData: {
          user_id: user._id,
          name: user.firstName,
          email: user.email.address,
        },
        service: `uploading ${withIndefiniteArticle(applicationRouteType)}`,
      }),
    );
  };

  return (
    <>
      <Stack alignItems="center" rowGap={6} textAlign="center" padding={8}>
        <Stack rowGap={3}>
          <Typography component="h2" id="modal-title" level="title-md">
            Upload Error
          </Typography>
          {errorResponseApiFlag() ? <ErrorMessage /> : <ErrorMessageV1 />}
        </Stack>
      </Stack>
      <Stack
        columnGap={2}
        alignItems="center"
        bgcolor="neutral.100"
        borderTop="1px solid"
        borderColor="neutral.200"
        paddingX={8}
        paddingY={5}
        flexDirection="row"
      >
        <Button variant="secondary" onClick={handleContactSupport} fullWidth>
          Contact Support
        </Button>
        <Button variant="primary" onClick={handleCloseSubmissionModal} fullWidth>
          Got It, Thanks!
        </Button>
      </Stack>
    </>
  );
};

export { SubmissionDenied };
